import React, { useContext, useState } from "react";
import AppContext from "../../../context/AppContext";
import {
  AreaChart,
  BarChart3,
  PieChart,
  Radar,
} from "lucide-react";
import translations from "../../common/Translations";
import CommonButton from "../../common/CommonButton";
import ModalCloseButton from "../../common/ModalCloseButton";
const ListChartModal = ({
  onClose,
  handleSelectedChart,
  handleCreateGraph,
}) => {
  const [selectedChart, setSelectedChart] = useState(null);
  const { theme, langMode } = useContext(AppContext);

  const modalTitle = translations[langMode]?.SelectChart;

  const chartInfo = {
    PIECHART: {
      name: translations[langMode].Piechart,
      icon: <PieChart className="h-9 w-9 text-yellow-500 transition-colors duration-200" />,
      verify: "chart",
    },
    BARCHART: {
      name: translations[langMode].barChart,
      icon: <BarChart3 className="h-9 w-9 text-blue-600 transition-colors duration-200" />,
      verify: "graph",
    },
    AREACHART: {
      name: translations[langMode].Areachart,
      icon: <AreaChart className="h-9 w-9 text-green-500 transition-colors duration-200" />,
      verify: "area",
    },
    RADARCHART: {
      name: translations[langMode].Radarchart,
      icon: <Radar className="h-9 w-9 text-purple-600 transition-colors duration-200" />,
      verify: "radar",
    },
  };

  const handleChartClick = (verify) => {
    setSelectedChart(verify);
    handleSelectedChart(verify);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 p-4">
      <div
        className={`relative w-full max-w-xl rounded-2xl shadow-2xl ${
          theme === "dark" ? "border border-gray-700 bg-gray-800 text-white" : ""
        } ${theme === "high-contrast" ? "border border-white bg-black text-white" : "bg-white"}`}
        dir={langMode === "ar" ? "rtl" : "ltr"}
      >
        <div
          className={`flex items-center justify-between border-b px-5 py-4 ${
            theme === "dark" ? "border-gray-700" : ""
          } ${theme === "high-contrast" ? "border-white" : "border-gray-200"}`}
        >
          <h3
            className={`text-lg font-bold sm:text-xl ${
              theme === "dark" ? "text-white" : theme === "high-contrast" ? "text-white" : "text-gray-800"
            }`}
          >
            {modalTitle}
          </h3>
          <ModalCloseButton
            onClick={onClose}
            className={langMode === "ar" ? "mr-auto ml-0" : "ml-auto mr-0"}
          />
        </div>

        <div className="p-5 sm:p-6">
          <div className="grid grid-cols-2 gap-4 sm:gap-5">
            {Object.entries(chartInfo).map(([key, { name, icon, verify }]) => (
              <button
                key={key}
                type="button"
                className={`group flex flex-col items-center justify-center rounded-xl border p-5 transition-all duration-200 ${
                  selectedChart === verify
                    ? "border-blue-500 bg-blue-50 text-blue-700"
                    : `border-gray-200 hover:border-blue-300 hover:bg-blue-50/40
                    ${theme === "dark" ? "border-gray-600 bg-gray-700 hover:bg-gray-600 text-gray-200" : ""}
                    ${theme === "high-contrast" ? "border-white bg-gray-900 hover:bg-gray-800 text-white" : "bg-white text-gray-700"}`
                }`}
                onClick={() => handleChartClick(verify)}
                aria-pressed={selectedChart === verify}
              >
                <div className="mb-3">
                  {React.cloneElement(icon, {
                    className: `${icon.props.className} ${selectedChart === verify ? "text-blue-600" : ""}`,
                  })}
                </div>
                <span
                  className={`text-center text-sm font-semibold sm:text-lg ${
                    selectedChart === verify
                      ? "text-blue-700"
                      : `${theme === "dark" ? "text-gray-200" : theme === "high-contrast" ? "text-white" : "text-gray-800"}`
                  }`}
                >
                  {name}
                </span>
              </button>
            ))}
          </div>

          <div className="flex justify-center mt-6">
            <CommonButton colorIntent="success"
              variant="primary"
              tooltipText={translations[langMode].canceltheselectedchart}
              tooltipPosition="top"
              onClick={handleCreateGraph}
            >
              {translations[langMode].create}
            </CommonButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListChartModal;
